import * as CL from '@design-system/component-library';
import { dsClass } from '../../../common/constants/dsClasses';
import { t } from '../../../common/i18n';
import { RespondentList } from '../../PbxAccordionContent/RespondentList';

interface MobileRespondentListProps {
  workingTimeNumbers?: string[];
  outOfOfficeNumbers?: string[];
  edit: boolean;
}

export const MobileRespondentList = ({ workingTimeNumbers, outOfOfficeNumbers, edit }: MobileRespondentListProps) => (
  <>
    <CL.Grid className={dsClass.PADDING_TOP_6}>
      <CL.GridRow>
        <CL.GridCol colsXS={4} colsS={6} colsM={3} colsL={6} colsXL={6}>
          <div className={`${dsClass.PADDING_BOTTOM_3} ${dsClass.DISPLAY_FLEX} ${dsClass.ALIGN_ITEMS_CENTER} `}>
            <h5 className={`${dsClass.MARGIN_0} ${dsClass.PADDING_RIGHT_2}`}>
              {t.OAGD('Office-hour backup respondents')}
            </h5>
            <CL.Tooltip
              triggerElement={
                <CL.Icon className="custom-icon" color="secondary-blue-600" icon="information" size="s" />
              }
              placement="top"
              i18n_tooltip_contentText={t.GUFJ(
                'The mobile number has two available chains (for office hours and out-of-office hours). You can add two respondents to both chains. Phone rings always first in users mobile number, and only after moves to spare respondents'
              )}
            />
          </div>
        </CL.GridCol>
      </CL.GridRow>
      <CL.GridRow>
        <RespondentList
          name="workingHoursReachabilityChain"
          edit={edit}
          isFirstRequired={false}
          numbers={workingTimeNumbers}
          numberOfRespondents={2}
          respondentLabel={t.GL5D('Backup respondent')}
        />
      </CL.GridRow>
    </CL.Grid>

    <CL.Grid className={dsClass.PADDING_TOP_6}>
      <CL.GridRow>
        <CL.GridCol colsXS={4} colsS={6} colsM={3} colsL={6} colsXL={6}>
          <div className={`${dsClass.PADDING_BOTTOM_3} ${dsClass.DISPLAY_FLEX} ${dsClass.ALIGN_ITEMS_CENTER} `}>
            <h5 className={`${dsClass.MARGIN_0} ${dsClass.PADDING_RIGHT_2}`}>
              {t.SMZW('Out-of-office backup respondents')}
            </h5>
            <CL.Tooltip
              triggerElement={
                <CL.Icon className="custom-icon" color="secondary-blue-600" icon="information" size="s" />
              }
              placement="top"
              i18n_tooltip_contentText={t.GUFJ(
                'The mobile number has two available chains (for office hours and out-of-office hours). You can add two respondents to both chains. Phone rings always first in users mobile number, and only after moves to spare respondents'
              )}
            />
          </div>
        </CL.GridCol>
      </CL.GridRow>
      <CL.GridRow>
        <RespondentList
          name="offWorkReachabilityChain"
          edit={edit}
          isFirstRequired={false}
          numbers={outOfOfficeNumbers}
          numberOfRespondents={2}
          respondentLabel={t.GL5D('Backup respondent')}
        />
      </CL.GridRow>
    </CL.Grid>
  </>
);
